export default __webpack_public_path__ + "static/media/06_photo.70973fc1.jpg";